// extracted by mini-css-extract-plugin
export default {"fileDownLoadLink":"FileDownLoad_fileDownLoadLink__zjCfD"};